/* Enhance discovery inside the native search drawer; keep Shopify predictive search intact. */
(() => {
  if (window.pwSearchDiscovery) return;
  window.pwSearchDiscovery = true;
  // Keep the readable rating when a privacy setting blocks the official brand CDN.
  const revealBrand = (image) => {
    if (image.matches?.('[data-pw-search-brand] img') && image.naturalWidth) {
      image.parentElement.dataset.ready = '';
    }
  };
  document.addEventListener('load', (event) => revealBrand(event.target), true);
  document.querySelectorAll('[data-pw-search-brand] img').forEach(revealBrand);
  const reset = (drawer, restoreFocus = false) => {
    const discovery = drawer.querySelector('[data-pw-search-discovery]');
    if (!discovery) return;
    discovery.querySelector('[data-pw-search-choices]').hidden = false;
    discovery.querySelector('[data-pw-search-matches]').hidden = true;
    if (restoreFocus) discovery.lastFilter?.focus();
  };
  document.addEventListener('click', (event) => {
    const drawer = event.target.closest('#search-drawer');
    if (!drawer) return;
    if (event.target.closest('[data-pw-search-back]')) return reset(drawer, true);
    const button = event.target.closest('[data-pw-search-filter]');
    if (!button) return;
    const discovery = button.closest('[data-pw-search-discovery]');
    const token = button.dataset.pwSearchFilter;
    let count = 0;
    discovery.querySelectorAll('[data-pw-search-tags]').forEach((product) => {
      product.hidden = !product.dataset.pwSearchTags.split(' ').includes(token);
      if (!product.hidden) count += 1;
    });
    discovery.lastFilter = button;
    discovery.querySelector('[data-pw-search-heading]').textContent = button.textContent;
    let category = count === 1 ? 'one' : 'other';
    let formattedCount = String(count);
    try {
      category = new Intl.PluralRules(discovery.dataset.locale).select(count);
      formattedCount = new Intl.NumberFormat(discovery.dataset.locale).format(count);
    } catch (_) { /* Keep the translated singular/plural fallback. */ }
    const template = discovery.getAttribute(`data-count-${category}`) || discovery.dataset.countOther;
    discovery.querySelector('[data-pw-search-count]').textContent = template.replaceAll('__count__', formattedCount);
    discovery.querySelector('[data-pw-search-choices]').hidden = true;
    discovery.querySelector('[data-pw-search-matches]').hidden = false;
    discovery.querySelector('[data-pw-search-heading]').focus();
  });
  // Mirror the predictive-search slot (idle / loading / results) on the drawer so CSS can react to it.
  const watchState = () => {
    document.querySelectorAll('#search-drawer predictive-search').forEach((ps) => {
      const slot = ps.shadowRoot && ps.shadowRoot.firstElementChild;
      const drawer = ps.closest('#search-drawer');
      if (!slot || !drawer || ps.dataset.pwWatched) return;
      ps.dataset.pwWatched = '';
      const sync = () => { drawer.dataset.pwSearchState = slot.getAttribute('name') || 'idle'; };
      new MutationObserver(sync).observe(slot, { attributes: true, attributeFilter: ['name'] });
      sync();
    });
  };
  if (window.customElements) window.customElements.whenDefined('predictive-search').then(watchState);
  document.addEventListener('DOMContentLoaded', watchState);
  document.addEventListener('reset', (event) => {
    const drawer = event.target.closest('#search-drawer');
    if (drawer) reset(drawer);
  });
})();
